import { useState } from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import "../styles/UtahAtAGlance.css";
import "../hexagon.css";
import "../styles/HexGrid.css";
import "../App.css";
import "../styles/UtahVerticals.css";
const auto = "/img/auto.webp";

const leftPanel = [
    // {
    //     logo: auto,
    //     label: "Autism and DD",
    //     title: "Autism and DD",
    //     text: "Autism and Developmental Disablities-STATISTICS powered by URADD",
    //     imagepath: "/img/glance-webp/auto1.webp",
    //     url: "/utah-at-a-glance/autism-dd",
    // },
    {
        label: "Budget",
        title: "Budget",
        text: "Explore Utah's budget overview: revenues, expenditures, and priorities across the state.",
        imagepath: "/img/glance-webp/utah-budget.webp",
        url: "/utah-at-a-glance/utah-budget",
    },
    {
    label: "Construction Intelligence",
    title: "Construction Intelligence",
    text: "Explore comprehensive construction metrics, workforce trends, and major projects in Utah's booming construction sector.",
    imagepath: "/img/landing-webp/cons.webp",
    url: "/utah-at-a-glance/construction-intelligence",
    },
    {
        label: "Hill Airforce Base Economic Impact",
        title: "Hill Airforce Base Economic Impact",
        text: "Hill Air Force Base in Utah is a major U.S. Air Force installation known for its critical role in aircraft maintenance...",
        imagepath: "/img/landing-webp/aerospace.webp",
        url: "/verticals/hill-airforce-base-economic-impact",
    },

    {
        label: "KCG Sandbox",
        title: "KCG Sandbox",
        text: "Research-grade KPIs turned into a clean, drillable web experience — built directly from the 2026 Economic Report to the Governor.",
        imagepath: "/img/landing-webp/KEMC.webp",
        url: "/kcg-sandbox",
    },
    {
        label: "Operation Gigawatt",
        title: "Utah Operation Gigawatt",
        text: "Explore Utah's Operation Gigawatt initiative focused on energy growth, infrastructure readiness, and long-term statewide capacity planning.",
        imagepath: "/img/glance-webp/powergrid.webp",
        url: "/utah-at-a-glance/utah-operation-gigawatt",
    },
    {
        label: "Mines",
        title: "Utah Mines",
        text: "Uncover the industrial heart of Utah with a detailed look at its major mines",
        imagepath: "/img/glance-webp/mines.webp",
        url: "/utah-at-a-glance/utah-mines",
    },
    {
        label: "NonProfits",
        title: "Nonprofits",
        text: "Utah is home to numerous non-profit organizations dedicated to serving communities, protecting the environment, supporting vulnerable populations, and enhancing quality of life across the state.",
        imagepath: "/img/glance-webp/nonprofits.webp",
        url: "/utah-at-a-glance/utah-nonprofits",
    },
    {
        label: "Utah Charter Schools",
        title: "Utah Charter Schools",
        text: "Utah's charter school system is a dynamic and growing part of the state's education landscape. These schools operate with greater autonomy than traditional public schools, allowing them to offer innovative programs and specialized learning environments to students across the state.",
        imagepath: "/img/landing-webp/utah-charter-school.webp",
        url: "/utah-at-a-glance/universities-and-schools/utah-schools/charter-schools",
    },
    {
        label: "Utah Schools",
        title: "Utah Schools",
        text: "Explore Utah's education landscape, from K-12 districts to higher education institutions, and understand how Utah is shaping the future of learning.",
        imagepath: "/img/landing-webp/utahschools.webp",
        url: "/utah-at-a-glance/universities-and-schools/utah-schools",
    },
    {
        label: "Utah Nonprofit Data Insights",
        title: "Utah Nonprofit Data Insights",
        text: "Explore Utah's nonprofit sector with data-driven insights on organizations, impact, and community engagement across the state.",
        imagepath: "/img/landing/service.webp",
        url: "/utah-at-a-glance/utah-nonprofits/nonprofit-data-insights",
    },



];

const WhatsNew = () => {
    return (
        <div>
            <LandingSection
                data={{
                    imageName: "whats-new-banner.webp",
                    title: "What's New on UTahData",
                    overlay: "linear-gradient(rgba(0, 0, 0, 0.4), rgba(161, 66, 66, 0.4))"
                }}
            />
            <div className="utah-at-a-glance-section">
                <div className="utah-at-a-glance-intro">
                    <div className="utah-at-a-glance-intro-sec1">
                        <h2>
                            New Frontiers. Fresh Insights. See Utah at a Glance.
                        </h2>
                    </div>
                    <div className="utah-at-a-glance-intro-sec2">
                        <p>
                            Stay updated with the latest trends and data points that help shape Utah. These 10 featured categories represent the most recent additions and updates to our platform, giving you a quick overview of what's evolving in the Beehive State.
                        </p>
                    </div>
                </div>
            </div>

            <div className="whats-new-grid-container">
                <div className="hex-row">
                    <ul id="hexGrid">
                        {leftPanel.slice(0, 3).map((btn, idx) => (
                            <li className="hex" key={idx}>
                                <div className="hexIn">
                                    <a className="hexLink" href={btn.url || "#"}>
                                        <div className="hexBorder">
                                            <div
                                                className="img"
                                                style={{
                                                    backgroundImage: `url(${btn.imagepath})`,
                                                }}
                                            >
                                                <div className="imgOverlay"></div>
                                            </div>
                                        </div>
                                        <div className="demo2">{btn.label}</div>
                                    </a>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="hex-row row-middle">
                    <ul id="hexGrid">
                        {leftPanel.slice(3, 7).map((btn, idx) => (
                            <li className="hex" key={idx}>
                                <div className="hexIn">
                                    <a className="hexLink" href={btn.url || "#"}>
                                        <div className="hexBorder">
                                            <div
                                                className="img"
                                                style={{
                                                    backgroundImage: `url(${btn.imagepath})`,
                                                }}
                                            >
                                                <div className="imgOverlay"></div>
                                            </div>
                                        </div>
                                        <div className="demo2">{btn.label}</div>
                                    </a>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="hex-row">
                    <ul id="hexGrid">
                        {leftPanel.slice(7, 10).map((btn, idx) => (
                            <li className="hex" key={idx}>
                                <div className="hexIn">
                                    <a className="hexLink" href={btn.url || "#"}>
                                        <div className="hexBorder">
                                            <div
                                                className="img"
                                                style={{
                                                    backgroundImage: `url(${btn.imagepath})`,
                                                }}
                                            >
                                                <div className="imgOverlay"></div>
                                            </div>
                                        </div>
                                        <div className="demo2">{btn.label}</div>
                                    </a>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default WhatsNew;
